import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ResetMode, ResetModeResult } from '../interfaces';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ResetModeServiceDataService {

  private uri: string = `${environment.apiUrl}list-reset-mode`;
  private headers:any ;

  constructor(
    private http: HttpClient
  ) {
    const jsonAuth = localStorage.getItem(AuthService.ATUH_STORAGE_KEY);
    if (jsonAuth) {
      const token = JSON.parse(jsonAuth)?.token;
      if (token) {
        // this.headers = new HttpHeaders({
        //   enctype: 'multipart/form-data',
        //   authorization: 'Bearer ' + token,
        // });

        this.headers = new HttpHeaders({

          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin':'*',
          enctype: 'multipart/form-data',
          authorization: 'Bearer ' + token,
        });
      } 
    }
  }

  getResetModes(): Observable<ResetModeResult|any> {
    return this.http.get(this.uri + "/all-modes");
  }

  addApplication(data: any): Observable<ResetMode|any> {
    return this.http.post(this.uri + '/add', data, { headers :this.headers });
  }

  updateApplication(data: any,id:any): Observable<ResetMode|any> {
    return this.http.post(this.uri + '/update'+ `/${id}`, data);
  }

  deleteApplication(data: ResetMode): Observable<null|any> {
    return this.http.put(this.uri + "/update_active" + `/${data.id}`, "");
  }

  associateResetMode(applicationId: number, resetModeId: number): Observable<any> {
    return this.http.put(`${this.uri}/${applicationId}/reset-mode`, { resetModeId });
  }

}
